<template>
  <div class="info-page">
    <crumbs title="政策通知" />
    <el-form
      :model="form"
      :rules="rules"
      ref="ruleForm"
      label-position="right"
      label-width="auto"
    >
      <div class="info-page__item">
        <div class="info-page__title">
          <span>政策详细信息</span>
        </div>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="政策标题" prop="name">
              <el-input
                v-model="form.name"
                placeholder="请输入政策标题"
                maxlength="200"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="关联政策解读" prop="policyDocumentation">
              <el-select
                style="width: 100%"
                v-model="form.policyDocumentation"
                multiple
                clearable
                filterable
                remote
                reserve-keyword
                placeholder="请输入关键词"
                no-data-text="无关联数据"
                :remote-method="loadRelevanceData"
                :loading="relevanceLoading"
              >
                <el-option
                  v-for="item in relevanceDatas"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="原文链接" prop="sourceURL">
              <el-input
                v-model="form.sourceURL"
                placeholder="请输入原文链接"
                maxlength="500"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="来源" prop="source">
              <el-input
                v-model="form.source"
                placeholder="请输入来源"
                maxlength="50"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="发文时间" prop="publishDate">
              <el-date-picker
                v-model="form.publishDate"
                type="date"
                placeholder="请选择发文时间"
                value-format="yyyy-MM-dd"
                prefix-icon="el-icon-date"
                style="width: 100%"
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="范围" prop="range">
              <enumerate
                url="/api/policy/getpolicyrange"
                v-model="form.range"
                placeholder="请选择范围"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="区域" prop="region">
              <province v-model="form.region" placeholder="请选择区域" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="主题" prop="directionSecond">
              <enumerate-radio
                url="/api/policy/getdirectionnew"
                v-model="form.directionSecond"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="政策内容" prop="content">
              <editor
                v-model="form.content"
                imgUploadUrl="/api/achievement/uploadachiattach"
              ></editor>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="是否推荐" prop="isRecommend">
              <el-switch
                v-model="form.isRecommend"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="政策关键词" prop="keywordList">
              <el-select
                v-model="form.keywordList"
                filterable
                allow-create
                default-first-option
                multiple
                :multiple-limit="5"
                clearable
                placeholder="请输入自定义创建的政策关键词"
                no-data-text="请输入政策关键词，按回车键确认创建，最多创建5个关键字"
                style="width: 100%"
              >
              </el-select>
              <div class="quick">
                <i>快速输入</i>
                <span
                  v-for="(item, index) in keyList"
                  :key="index"
                  @click="handleKeys(item)"
                  >{{ item }}</span
                >
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="附件上传" prop="fileUploadList">
              <file-upload
                url="/api/policy/uploadpolicyattach"
                :file-list.sync="form.fileUploadList"
                accept=""
                :num-limit="0"
              >
                <el-alert
                  style="margin-top: 10px; line-height: normal"
                  :title="`上传文件格式要求ppt、pdf、doc、docx、txt、xls、xlsx、压缩包；文件名(包含后缀名)的最大长度为100个字符`"
                  type="warning"
                >
                </el-alert>
              </file-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>

    <div class="submit fn-text-center mt-20">
      <template v-if="isAudit">
        <el-button
          type="danger"
          :loading="isLoading"
          plain
          @click="handlerAuditData('ruleForm', false)"
          >审核不通过</el-button
        >
        <el-button
          type="success"
          :loading="isLoading"
          plain
          @click="handlerAuditData('ruleForm', true)"
          >审核通过</el-button
        >
      </template>
      <template v-else>
        <template v-if="isAdd">
          <el-button
            type="primary"
            :loading="isLoading"
            plain
            @click="handlerAddData('ruleForm')"
            >提交</el-button
          >
        </template>
        <template v-else>
          <el-button
            type="primary"
            :loading="isLoading"
            plain
            @click="handlerModifyData('ruleForm')"
            >提交</el-button
          >
        </template>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "policyInfo",
  data() {
    const isEmpty = (
      message = "该项值不能为空",
      trigger = ["blur", "change"]
    ) => {
      return {
        required: true,
        message,
        trigger
      };
    };
    return {
      // 是否处于loading状态
      isLoading: false,
      //是添加数据还是修改数据
      isAdd: true,
      // 是否是审核
      isAudit: false,
      keyList: [],
      //表单
      form: {
        name: "",
        policyDocumentation: [],
        source: "",
        sourceURL: "",
        publishDate: "",
        range: "",
        region: "",
        directionSecond: "",
        content: "",
        isRecommend: 0,
        keywordList: [], // keyword 相对应 分号分隔
        fileUploadList: [] // attachFiles 相对应
      },
      rules: {
        name: [isEmpty("请输入政策标题")],
        publishDate: [isEmpty("请选择发文时间", "change")],
        content: [isEmpty("请编辑政策内容")],
        range: [isEmpty("请选择范围", "change")],
        region: [isEmpty("请选择区域", "change")],
        directionSecond: [isEmpty("请选择主题", "change")]
      },
      // 关联数据
      relevanceLoading: false,
      relevanceDatas: []
    };
  },
  created() {
    const { method } = this.$route.params;
    // 默认值 走添加流程
    let isAdd = true,
      isAudit = false;
    if (method === "audit") {
      //获取信息
      this.loadInfo();
      //走审核流程
      isAudit = true;
    } else if (method === "modification") {
      //获取信息
      this.loadInfo();
      //走修改流程
      isAdd = false;
    }
    this.isAdd = isAdd;
    this.isAudit = isAudit;
    this.getKeys();
  },
  methods: {
    getKeys() {
      this.$api("policy", "getMessageKeys", {}).then((res) => {
        this.keyList = res.dataList;
      });
    },
    handleKeys(item) {
      this.form.keywordList.includes(item) || this.form.keywordList.push(item);
    },
    // 正向处理数据 将数据处理后提交
    processDataSubmit() {
      const {
        // integer
        range,
        directionSecond,
        // list
        keywordList,
        fileUploadList,
        ...others
      } = this.form;
      // 处理 keywordList
      const keyword = keywordList.join(";");
      // 处理上传文件
      const deconstruct = (file = {}) => {
        return file.response ? file.response.dataList[0] : file;
      };
      const turnFile = {
        attachFiles: fileUploadList
      };
      Object.keys(turnFile).map((key) => {
        turnFile[key] = turnFile[key].map((item) => {
          return deconstruct(item);
        });
      });
      // 处理字符串 转为数字
      const turnNumber = {
        range,
        directionSecond
      };
      Object.keys(turnNumber).map((key) => {
        turnNumber[key] = turnNumber[key] === "" ? -1 : turnNumber[key];
      });
      return {
        ...others,
        ...turnNumber,
        ...turnFile,
        keyword
      };
    },
    // 逆向处理数据 获取后进行数据处理回显
    downloadProcessData(data) {
      const {
        // -1 => ""
        range,
        directionSecond,
        // 去分号
        keyword,
        attachFiles,
        ...others
      } = data;
      // 处理 keyword
      const keywordList =
        this.turnNulltoString(keyword) === ""
          ? []
          : this.turnNulltoString(keyword).split(";");
      // 处理文件
      const turnFile = {
        fileUploadList: attachFiles
      };
      Object.keys(turnFile).map((key) => {
        const file = this.turnNulltoString(turnFile[key]);
        turnFile[key] = file === "" ? [] : file;
      });
      // 处理数字 转为字符串
      const turnNumber = {
        range,
        directionSecond
      };
      Object.keys(turnNumber).map((key) => {
        turnNumber[key] = turnNumber[key] === -1 ? "" : turnNumber[key];
      });
      return {
        ...others,
        ...turnNumber,
        ...turnFile,
        keywordList
      };
    },
    // 点击添加数据按钮
    handlerAddData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadAddData();
        }
      });
    },
    // 点击修改数据按钮
    handlerModifyData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadModifyData();
        }
      });
    },
    // 点击审核数据
    handlerAuditData(formName, bool) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadModifyData(bool);
        }
      });
    },
    // 加载添加数据接口
    loadAddData() {
      this.isLoading = true;
      const params = this.processDataSubmit();
      this.$api("policy", "addMessage", params).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.redirectTo();
        }
      });
    },
    // 加载修改数据接口/审核数据接口
    loadModifyData(isAudit) {
      const auditStatus = isAudit === undefined ? undefined : isAudit ? 1 : 2;
      this.isLoading = true;
      const params = this.processDataSubmit();
      const { id } = this.$route.query;
      this.$api("policy", "addMessage", {
        ...params,
        auditStatus,
        id
      }).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.redirectTo();
        }
      });
    },
    // 加载数据接口
    loadInfo() {
      const { id } = this.$route.query;
      this.$api("policy", "getMessageInfo", { id }).then((res) => {
        const { code, message } = res;
        if (code === 0) {
          this.form = this.downloadProcessData(res.model);
          this.relevanceDatas = res.model.pdSimpleModel;
        } else {
          this.$message.error(message);
          this.redirectTo();
        }
      });
    },
    loadRelevanceData(keyWord) {
      if (keyWord !== "") {
        this.relevanceLoading = true;
        this.$api("policy", "getExplainList", {
          keyWord,
          pageIndex: 1,
          pageSize: 10
        }).then((res) => {
          this.relevanceLoading = false;
          this.relevanceDatas = res.code === 0 ? res.dataList : [];
        });
      } else {
        this.relevanceDatas = [];
      }
    },
    // 返回列表页
    redirectTo() {
      // this.redirectByPath(`/admin/policyManage/policyMessageList`);
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="less" scoped>
.info-page {
  .quick {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    i {
      font-style: normal;
      margin-right: 20px;
    }
    span {
      padding: 0 10px;
      margin: 10px 20px 10px 0;
      line-height: 20px;
      border-radius: 15px;
      background-color: @mainColor;
      color: #fff;
      cursor: pointer;
    }
  }
}
</style>
